import type { FaireProductEntity } from "../../entity_types/product";

export const plant_dyed_2: FaireProductEntity = {
  token: "plant-dyed-2",
  type: "product",
  name: "Terracotta Desert Coat",
  brandName: "Happy French Gang",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/edd9b57a14e8f449cd99c8dc322dcd7c458a71f44e452446e8a5bff02abfb964.png",
  priceDollars: 145,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/edd9b57a14e8f449cd99c8dc322dcd7c458a71f44e452446e8a5bff02abfb964.png",
  weight: 1.5,
  dimensions: {
    width: 20,
    height: 40,
    depth: 2,
  },
  description: "Terracotta desert coat with plant-dyed textiles",
  categoryTokens: ["cat_accessories"],
  tags: [
    "plant-dyed",
    "natural-dye",
    "sustainable-textiles",
    "apparel",
    "coat",
    "premium",
  ],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
